import { createSelector } from 'reselect';
import BalanceOnHandReportColumns from '../../containers/BalanceOnHandReportColumns';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_BALANCE_ON_HAND_PAGE.isLoading;
export const getData = TableDefinitions.REPORTING_BALANCE_ON_HAND_PAGE.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandReportColumns);
